import _timerange from "./_timerange";

export default {
    parse: function(string) {
        const result = _timerange.parse(string);
        return result === null ? null : result.start;
    },

    format: function(timestamp) {
        return _timerange.format(timestamp);
    }
};



// WEBPACK FOOTER //
// ./src/abusesa-js/formats/timestamp.js